import { render, staticRenderFns } from "./Administrador.vue?vue&type=template&id=f3291928"
import script from "./Administrador.vue?vue&type=script&lang=js"
export * from "./Administrador.vue?vue&type=script&lang=js"
import style0 from "../main.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports